module.exports = "#main {\n    margin-left: 0;\n}\n\n.login-form-container {\n    padding-left: 20px;\n}\n\n.container {\n    margin-right: 10% !important;\n}\n\n#header .system-info-container {\n    color: white;\n}\n\n#header .system-info-container img {\n    width: 50px;\n    display: inline-block;\n    padding-left: 10px;\n    vertical-align: middle;\n    margin-top: 10px;\n}\n\n#header .system-info-container h1 {\n    padding-left: 15px;\n    display: inline-block;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/+app-custom/views/login/login.component.css
// module id = ./src/app/+app-custom/views/login/login.component.css
// module chunks = main